<img src="assets/sports/img/sport-images/clean-cache-won-g.png" class="betslip-unlocker-modal--image" />
<ion-card class="betslip-unlocker--card">
  <ion-card-header>
    <ion-card-title>{{ 'SPO_BUnlockerModalTitle' | translate }}</ion-card-title>
  </ion-card-header>

  <ion-card-content>
    <p>
      {{ 'SPO_BUnlockerModalParagraph' | translate }}
    </p>
    <p>
      <b>{{ 'SPO_BUnlockerModalQuestion' | translate }}</b>
    </p>
  </ion-card-content>
  <div class="btn-row">
    <ion-button fill="outline" expand="block" size="large" (click)="cancel()">{{ 'tCancel' | translate }} </ion-button>
    <ion-button expand="block" size="large" (click)="accept()">{{ 'SPO_Restart' | translate }} </ion-button>
  </div>
</ion-card>
